/**
 * Clamps the given value between the specified min and max.
 * @param value The value to clamp.
 * @param max The max value.
 * @param min The min value. Defaults to 0.
 */
export function clampValue(value: number, min: number, max: number) {
  return Math.max(Math.min(value, max), min);
}
